import { render, staticRenderFns } from "./upload-certificate-dfr-2.vue?vue&type=template&id=b23bc6e2&"
import script from "./upload-certificate-dfr-2.vue?vue&type=script&lang=js&"
export * from "./upload-certificate-dfr-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports